import ConfigurationSummaryConfirmationCardTypeEnum from '../enums/ConfigurationSummaryConfirmationCardTypeEnum.js';
import type IConfigurationSummaryTranslations from '../types/IConfigurationSummaryTranslations.js';

export default class ConfigurationSummaryCardUtility {
	public static getSheetBodyTitleText(
		translations: IConfigurationSummaryTranslations,
		type: ConfigurationSummaryConfirmationCardTypeEnum | null
	): string {
		const {
			confirmationCardAddToShoppingCartSuccess,
			confirmationCardAddToShoppingListSuccess,
			addToShoppingCartFailureHeadline
		} = translations;

		switch (type) {
			case ConfigurationSummaryConfirmationCardTypeEnum.addToCartSuccess:
			case ConfigurationSummaryConfirmationCardTypeEnum.addUnavailabeToCartAndListSuccess:
			case ConfigurationSummaryConfirmationCardTypeEnum.addUnavailabeToCartSuccessAndListFail:
				return confirmationCardAddToShoppingCartSuccess;

			case ConfigurationSummaryConfirmationCardTypeEnum.addToListSuccess:
				return confirmationCardAddToShoppingListSuccess;

			case ConfigurationSummaryConfirmationCardTypeEnum.addUnavailabeToCartFailAndListSuccess:
				return addToShoppingCartFailureHeadline;

			default:
				return '';
		}
	}
}
